<template>
  <b-form-checkbox
    id="terms-of-use-checkbox"
    v-model="$v.termsOfUse.$model"
    name="checkbox-1"
    class="sign-up-checkbox terms"
    :state="!isTermsOfUseValid ? false : null"
  >
    <div class="terms-of-use-label-text">
      I've read and agreed to the
      <a :href="`${landingPage}/terms-of-use`" target="_blank" class="link">terms of use</a> and
      <a :href="`${landingPage}/privacy-notes`" target="_blank" class="link">privacy notice</a>
    </div>
    <div v-if="!isTermsOfUseValid" class="mt-2 mb-2">
      Please read and accept our legal terms to continue
    </div>
  </b-form-checkbox>
</template>

<script>
import { validationMixin } from 'vuelidate'

export default {
  name: 'TermsOfUseCheckbox',
  mixins: [validationMixin],
  data () {
    return {
      termsOfUse: false
    }
  },
  validations: {
    termsOfUse: {
      accepted (value) {
        return value === true
      }
    }
  },
  computed: {
    landingPage () {
      return process.env.VUE_APP_LANDING_PAGE
    },
    isTermsOfUseValid () {
      if (!this.$v.termsOfUse.$error) {
        return true
      }

      return !this.$v.termsOfUse.$invalid
    }
  }
}
</script>

<style scoped lang="scss">
.terms {
  margin-top: 30px;
}

.terms-of-use-label-text {
  color: $fontColorBase;
}

.link {
  line-height: inherit;
  font-size: inherit;
}
</style>
